export default __webpack_public_path__ + "assets/svg/excercises.553cb46e6ce0d42e5bc3b38a69ae3208.svg";